<template>
  <div>
    <div class="row">
      <div
        v-for="(item, i) in visibleItems"
        :key="i"
        class="col-12 col-lg-3 col-md-4 text-center"
        style="cursor: pointer"
        @click="go(item)"
      >
        <div class="card card-body home-btn">
          <h2><i :class="'fa ' + item.icon"></i> <br />{{ item.title }}</h2>
          <small v-if="item.desc" class="text-muted">{{ item.desc }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // كل عناصر قائمة اللجان (عدا الرئيسية) — المجموعات مسطّحة إلى أزرار
      items: [
        { title: "استعراض الطلاب", icon: "fa-users", route: "students|list2", desc: "إدارة الطلاب" },
        { title: "استيراد / اضافة الطلاب", icon: "fa-user-plus", route: "students|add", desc: "من ملف نور أو يدوياً" },
        { title: "ادارة الفصول", icon: "fa-object-group", route: "students|move", desc: "نقل وتنظيم الفصول" },
        { title: "استعراض المعلمين", icon: "fa-user", route: "lessons|teachers2", desc: "إدارة المعلمين" },
        { title: "إضافة معلم جديد", icon: "fa-user-plus", route: "lessons|teachers-add2" },
        { title: "استيراد المعلمين", icon: "fa-upload", route: "teachers-import" },
        { title: "توزيع اللجان", icon: "fa-star", route: "committees|create", desc: "بعد استيراد الطلاب" },
        { title: "سجل عمليات التوزيع", icon: "fa-list", route: "committees|history" },
        { title: "تقرير الحضور والغياب", icon: "fa-pie-chart", route: "committees|reports-all" },
        { title: "النماذج والكشوف", icon: "fa-file-text-o", route: "committees|school-kushof", desc: "نماذج وكشوف أعمال الاختبارات" },
        { title: "ارشيف الرسائل", icon: "fa-archive", route: "archive_committees", per: "archive" },
        { title: "الاعدادات", icon: "fa-cog", route: "committees|settings" },
        {
          title: "شروحات النظام",
          icon: "fa-youtube-play",
          href: "https://tahdir.net/%D8%A7%D9%84%D9%85%D9%88%D8%A7%D8%B6%D9%8A%D8%B9",
          desc: "مشاهدة الشروحات",
        },
      ],
    };
  },
  computed: {
    // إظهار العناصر التي لا تتطلب صلاحية أو يملكها المستخدم
    visibleItems() {
      return this.items.filter((it) => !it.per || (typeof checkPer === "function" && checkPer(it.per)));
    },
  },
  created() {
    if (!checkPer("committees")) {
      this.$router.push("/NotPermitted");
      return false;
    }
  },
  methods: {
    go(item) {
      if (item.href) {
        window.open(item.href, "_blank");
        return;
      }
      if (this.$route.name === item.route) return;
      this.$router.push({ name: item.route }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.home-btn {
  transition: transform 0.15s, box-shadow 0.15s;
  min-height: 140px;
  justify-content: center;
}
.home-btn:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
}
.home-btn h2 {
  margin-bottom: 4px;
}
.home-btn i {
  color: #2e9b9b;
}
</style>
